import React from 'react';

const ContractViewer = ({ htmlContent }) => {
  return <div className='w-100' style={{overflowX: "auto"}} dir='rtl' dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default ContractViewer;
